/**
 * ActorID enum - All actor definition IDs
 */
export enum ActorID {
    HERO = 'hero',
    SNOWMAN = 'snowman', 
    SNOW_SPRITE = 'snow_sprite',
    SNOW_GOLEM = 'snow_golem',
    FROST_GIANT = 'frost_giant',
    KRAMPUS = 'krampus',
    // Stub out other IDs used in spawn tables
    FROST_WISP = 'frost_wisp',
    ICE_SPIDER = 'ice_spider',
    ICE_WRAITH = 'ice_wraith',
    WINTER_WOLF = 'winter_wolf',
    ICE_DRAGON = 'ice_dragon',
    BLIZZARD_ELEMENTAL = 'blizzard_elemental',
    CORRUPTED_SANTA = 'corrupted_santa',
    GINGERBREAD_GOLEM = 'gingerbread_golem',
    CANDY_CANE_SPIDER = 'candy_cane_spider',
    NUTCRACKER_SOLDIER = 'nutcracker_soldier',
    EVIL_ELF = 'evil_elf',
}
